// A placeholder block sized to match the real content it stands in for, so
// swapping from skeleton to real content changes pixels, not layout.
export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded bg-paper2 ${className}`} />;
}
